<template>
    <v-container class="px-8 py-8">
        <v-row class="pa-4" :justify="'center'">
            <v-col cols="12" md="6">
                <v-card rounded="lg">
                    <v-card-title class="primary white--text">
                        <span class="text-h6">Update Artikel</span>
                        <v-spacer></v-spacer>
                        <v-btn icon color="white" @click="deleteDialog = true">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-container class="py-5">
                                <v-text-field v-model="title" label="Judul" placeholder="Judul Artikel" dense outlined
                                    required :rules="titleRules">
                                </v-text-field>
                                <v-textarea rows="10" v-model="content" outlined name="content" label="Konten"
                                    :rules="contentRules">
                                </v-textarea>
                                <v-file-input label="Gambar" outlined accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera" :rules="fileRules" dense @change="onFileChange">
                                </v-file-input>
                                <v-text-field v-model="author" label="Author" placeholder="Penulis" dense outlined
                                    required :rules="authorRules">
                                </v-text-field>

                                <v-btn @click="submit" color="primary">
                                    Submit
                                </v-btn>

                                <v-dialog v-model="showDialog" width="500">

                                    <v-card rounded="lg">
                                        <v-card-title class="text-h5 primary white--text">
                                            Konfirmasi
                                        </v-card-title>

                                        <v-card-text class="subtitle-1">
                                            <p>Apakah semua data yang dimasukkan telah benar?</p>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>

                                            <v-btn color="primary" text @click="showDialog = false">
                                                Batal
                                            </v-btn>
                                            <v-btn color="primary" @click="updateArticle">
                                                Submit
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-container>
                        </v-form>
                    </v-card-text>

                    <v-card-actions>

                    </v-card-actions>
                </v-card>

                <LoadingDialog v-if="onLoading" :show-dialog=onLoading></LoadingDialog>
                <AlertDialog :show-dialog="alertDialog" :message=alertMessage :type=alertType
                    @onchange="onAlertDialogChange">
                </AlertDialog>

                <v-dialog v-model="deleteDialog" width="500">

                    <v-card rounded="lg">
                        <v-card-title class="text-h5 primary white--text">
                            Konfirmasi
                        </v-card-title>

                        <v-card-text class="subtitle-1">
                            Apakah anda yakin ingin menghapus article ini?
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn color="primary" text @click="deleteDialog = false">
                                Batal
                            </v-btn>
                            <v-btn color="primary" @click="deleteArticle">
                                Oke
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import LoadingDialog from '@/components/LoadingDialog.vue';
import AlertDialog from '@/components/AlertDialog.vue';

import service from '../../services/index'
import { BASE_URL } from '@/constant';
import router from '@/router';

export default {
    name: 'ArticlesUpdateView',
    data() {
        return {
            article: null,
            FILE: null,
            valid: true,
            title: '',
            content: '',
            author: '',
            titleRules: [
                v => !!v || 'Judul harus diisi',
            ],
            authorRules: [
                v => !!v || 'Author harus diisi',
            ],
            contentRules: [
                v => !!v || 'Konten harus diisi',
            ],
            fileRules: [
                value => !value || value.size < 2000000 || 'Image tidak boleh lebih dari 2 MB!',
            ],
            showDialog: false,
            onLoading: false,
            alertDialog: false,
            alertMessage: '',
            alertType: "Sukses",
            deleteDialog: false
        }
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.showDialog = true
            }
            // this.onLoading = true
        },
        async updateArticle() {
            this.showDialog = false
            this.onLoading = true
            var data = new FormData()

            if (this.FILE) {
                data.append('image', this.FILE, this.FILE.name)
            }
            data.append('title', this.title)
            data.append('content', this.content)
            data.append('author', this.author)

            try {
                var response = await service.updateData(BASE_URL + '/articles/' + this.$route.params.id, data)

                if (response.status == 200) {
                    this.alertType = "Sukses"
                    this.alertMessage = "Artikel berhasil diupate"
                    this.alertDialog = true

                    this.$refs.form.reset()

                    setTimeout(function () {
                        router.replace({ name: 'articles' })
                    }, 2000)
                }
            } catch (error) {
                this.alertType = "Gagal"
                this.alertMessage = "Gagal menambahkan artikel"
                this.alertDialog = true
            }

            this.onLoading = false
        },
        async getArticle(id) {
            this.onLoading = true

            try {
                var response = await service.getData(BASE_URL + '/articles/' + id, null)

                if (response.status == 200) {
                    this.article = response.data.data

                    if (!this.article) {
                        this.alertType = "Gagal"
                        this.alertMessage = "Artikel tidak ditemukan"
                        this.alertDialog = true

                        router.replace({ name: 'articles' })
                    }

                    this.title = this.article.title
                    this.content = this.article.content
                    this.author = this.article.author
                }
            } catch (error) {
                this.alertType = "Gagal"
                this.alertMessage = "Terjadi kesalahan dalam memuat artikel"
                this.alertDialog = true
            }

            this.onLoading = false
        },

        async deleteArticle() {
            try {
                this.deleteDialog = false
                this.onLoading = true
                var response = await service.deleteData(BASE_URL + '/articles/' + this.$route.params.id, null)

                if (response.status == 200) {
                    this.alertType = "Sukses"
                    this.alertMessage = "Artikel berhasil dihapus"
                    this.alertDialog = true

                    setTimeout(function () {
                        router.replace({ name: 'articles' })
                    }, 2000)
                }
            } catch (error) {
                console.log(error)
                this.alertType = "Gagal"
                this.alertMessage = "Terjadi kesalahan dalam memuat artikel"
                this.alertDialog = true
            }

            this.onLoading = false
        },

        onAlertDialogChange(e) {
            this.alertDialog = e
        },
        onFileChange(files) {
            console.log('ke trigger bos')
            this.FILE = files
        }
    },
    computed: {
        passwordConfirmationRule() {
            return () =>
                this.password === this.confirmPassword || "Password tidak sama";
        }
    },
    mounted() {
        var id = this.$route.params.id
        this.getArticle(id)
    },
    components: {
        LoadingDialog,
        AlertDialog
    }
}
</script>